<script>
import LongCollapsableText from './TextSubElement/LongCollapsableText.vue';

export default {
  components: { LongCollapsableText },
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  <router-link
    :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    class="member-name"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.member.updateAbout.p1')}}
  <div class="news-addition-info">
    <LongCollapsableText :news-id="news.id" :text="news.textParams[2]"/>
  </div>
</div>
</template>
